
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/wines/lists/[...slug]",
      function () {
        return require("private-next-pages/wines/lists/[...slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/wines/lists/[...slug]"])
      });
    }
  